    <div class="container-fluid">
        <div class="row mt-4">
            <div class="col">
                <h5 class="blue"><i class="fas fa-pencil-alt"></i>&nbsp;Editar Compañia</h5>
            </div>
        </div>
        <hr>

        <form #formNuevaCompania="ngForm" (ngSubmit)="formSubmit(formNuevaCompania)" novalidate="">


            <div class="row mt-3">
                <div class="col col-12">
                    <label class="form-label">Clave:</label>
                    <input type="text" autocomplete="off" class="form-control form-control-sm custom-input" placeholder="Clave" name="txtClave" #txtClave="ngModel" [(ngModel)]='CompaniaRQ.clave' maxlength="10" pattern="^[a-zA-ZÀ-ÿñÑ\s]{2,10}$" required>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col col-12">
                    <label class="form-label">Descripción:</label>
                    <input type="text" autocomplete="off" class="form-control form-control-sm custom-input" placeholder="Descripción" name="txtDescripcion" #txtDescripcion="ngModel" [(ngModel)]='CompaniaRQ.descripcion' maxlength="100" pattern="^[a-zA-ZÀ-ÿñÑ\s]{2,100}$" required>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col text-end">
                    <button type="button" (click)="onClose()" class="btn btn-sm rounded-button btn-secondary">
                                <i class="fa fa-arrow-left"></i>
                                Regresar
                    </button>
                    <button type="submit" [disabled]="!formNuevaCompania.form.valid" class="side-space btn btn-sm rounded-button btn-success">
                        Aceptar
                        <i class="fa fa-check"></i>
                    </button>
                </div>
            </div>
        </form>

    </div>